var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-button',{attrs:{"icon":"plus","is-loading":_vm.loading,"disabled":_vm.isDisabled},on:{"click":_vm.createNextOrder}},[_vm._v(" "+_vm._s(_vm.$t('RecurringOrder.createNextOrder'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }